import React, { useEffect } from "react";
import tw from "tailwind-styled-components";
import dayjs from "dayjs";
import { loadSingleStaff } from "../../redux/rtk/features/user/userSlice";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import BtnDeleteSvg from "./Button/btnDeleteSvg";
import { deleteSalaryHistory } from "../salaryHistory/salaryHistoryApis";
import SalaryEditSinglePopup from "./PopUp/SalaryEditSinglePopup";
import SalaryTimelineSvg from "./SalaryTimelineSVG";
import { loadSalaryByUserId } from "../../redux/rtk/features/salary/salarySlice";

const EmployeeSalary = ({ list, edit, setLoading }) => {
  const user_id = useParams("id");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadSalaryByUserId(user_id.id));
  }, [dispatch]);

  const deletedSalaryHistory = async (id) => {
    setLoading(true);
    const { data } = await deleteSalaryHistory(id);

    // check if data is deleted or not and call the setPopUp function
    if (data) {
      dispatch(loadSingleStaff(user_id.id));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  // Check if list is empty or undefined
  if (!list || list.length === 0) {
    return <p>No salary information available</p>;
  }

  // Group salary history items by start date
  const groupedByStartDate = list.reduce((acc, item) => {
    const startDateKey = dayjs(item.startDate).format('YYYY-MM-DD');
    if (!acc[startDateKey]) {
      acc[startDateKey] = [];
    }
    acc[startDateKey].push(item);
    return acc;
  }, {});

  return (
    <div>
      <main className="container mx-auto w-full flex justify-center mt-5">
        <ol className="border-l-2 border-slate-600">
          {Object.entries(groupedByStartDate).map(([startDate, items]) => {
            // For display purposes, all items with same start date should have same end date
            const firstItem = items[0];
            
            // Create pairs of items for two-column layout
            const createPairs = (items) => {
              let pairs = [];
              for (let i = 0; i < items.length; i += 2) {
                if (i + 1 < items.length) {
                  pairs.push([items[i], items[i + 1]]);
                } else {
                  pairs.push([items[i], null]);
                }
              }
              return pairs;
            };

            const itemPairs = createPairs(items);
            
            return (
              <li key={startDate}>
                <div className="md:flex flex-start">
                  <SalaryTimelineSvg />
                  <div className="block p-6 max-w-md ml-6 mb-5">
                    <div className="flex justify-between mb-4">
                      <Heading>
                        {dayjs(firstItem?.startDate).format("YYYY")} -{" "}
                        {firstItem?.endDate
                          ? dayjs(firstItem?.endDate).format("YYYY")
                          : "Present"}
                      </Heading>

                      {edit && (
                        <div>
                          <SalaryEditSinglePopup
                            data={items}
                            setLoading={setLoading}
                          />

                          <button
                            onClick={() => {
                              // Delete all items with the same start date
                              items.forEach(item => {
                                deletedSalaryHistory(item.id);
                              });
                            }}>
                            <BtnDeleteSvg size={20} />
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Display date information */}
                    <div className="mb-4">
                      <Heading1>
                        Start Date:{" "}
                        <Heading2>
                          {dayjs(firstItem?.startDate).format("DD/MM/YYYY")}
                        </Heading2>
                      </Heading1>

                      <Heading1>
                        End Date:{" "}
                        <Heading2>
                          {firstItem.endDate
                            ? dayjs(firstItem?.endDate).format("DD/MM/YYYY")
                            : "Present"}
                        </Heading2>
                      </Heading1>
                    </div>

                    {/* Display salary components in 2-column grid */}
                    <div className="grid grid-cols-2 gap-y-2">
                      {items.map((item, index) => (
                        <div key={item.id || index} className={index % 2 === 1 ? "pl-4" : "pr-4"}>
                          <Heading1>
                            {item.salaryComponent?.componentName || "Salary"}: {" "}
                            <Heading2>{item.value || item.salary}</Heading2>
                          </Heading1>
                          
                          {item.comment && (
                            <Heading1 className="mt-1">
                              Comment: <Heading2>{item.comment}</Heading2>
                            </Heading1>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
      </main>
    </div>
  );
};

const Heading = tw.h3`
font-medium
text-base
mr-20
w-500
txt-color-2
`;

const Heading1 = tw.h3`
font-medium
text-sm
mr-20
w-500
txt-color-2
`;

const Heading2 = tw.span`
font-medium 
text-sm
txt-color-secondary`;

export default EmployeeSalary;

// import React, { useEffect } from "react";
// import tw from "tailwind-styled-components";
// import dayjs from "dayjs";
// import { loadSingleStaff } from "../../redux/rtk/features/user/userSlice";
// import { useDispatch } from "react-redux";
// import { useParams } from "react-router-dom";
// import BtnDeleteSvg from "./Button/btnDeleteSvg";
// import { deleteSalaryHistory } from "../salaryHistory/salaryHistoryApis";
// import SalaryEditSinglePopup from "./PopUp/SalaryEditSinglePopup";
// import SalaryTimelineSvg from "./SalaryTimelineSVG";
// import { loadSalaryByUserId } from "../../redux/rtk/features/salary/salarySlice";

// const EmployeeSalary = ({ list, edit, setLoading }) => {
// 	const user_id = useParams("id");
// 	const dispatch = useDispatch();

// 	useEffect(() => {
// 		dispatch(loadSalaryByUserId(user_id.id));
// 	}, [dispatch]);

// 	const deletedSalaryHistory = async (id) => {
// 		setLoading(true);
// 		const { data } = await deleteSalaryHistory(id);

// 		// check if data is deleted or not and call the setPopUp function
// 		if (data) {
// 			dispatch(loadSingleStaff(user_id.id));
// 			setLoading(false);
// 		} else {
// 			setLoading(false);
// 		}
// 	};

// 	// Check if list is empty or undefined
// 	if (!list || list.length === 0) {
// 		return <p>No salary information available</p>;
// 	}

// 	return (
// 		<div>
// 			<main className="container mx-auto w-full flex justify-center mt-5">
// 				<ol className="border-l-2 border-slate-600">
// 					{list.map((item) => {
// 						return (
// 							<li key={item.id}>
// 								<div className="md:flex flex-start">
// 									<SalaryTimelineSvg />
// 									<div className="block p-6 max-w-md ml-6 mb-5">
// 										<div className="flex justify-between mb-4">
// 											{/* Display salary component name and value */}
// 											<Heading>
// 												{item.salaryComponent?.componentName || "Salary"}: {item.value || item.salary}
// 											</Heading>

// 											<Heading>
// 												{dayjs(item?.startDate).format("YYYY")} -{" "}
// 												{item?.endDate
// 													? dayjs(item?.endDate).format("YYYY")
// 													: "Present"}
// 											</Heading>

// 											{edit && (
// 												<div>
// 													<SalaryEditSinglePopup
// 														data={item}
// 														setLoading={setLoading}
// 													/>

// 													<button
// 														onClick={() => deletedSalaryHistory(item.id)}>
// 														<BtnDeleteSvg size={20} />
// 													</button>
// 												</div>
// 											)}
// 										</div>

// 										{item.comment && (
// 											<Heading1>
// 												Comment: <Heading2>{item.comment}</Heading2>
// 											</Heading1>
// 										)}
										
// 										<Heading1>
// 											Start Date:{" "}
// 											<Heading2>
// 												{dayjs(item?.startDate).format("DD/MM/YYYY")}
// 											</Heading2>
// 										</Heading1>

// 										<Heading1>
// 											End Date:{" "}
// 											<Heading2>
// 												{item.endDate
// 													? dayjs(item?.endDate).format("DD/MM/YYYY")
// 													: "Present"}
// 											</Heading2>
// 										</Heading1>
// 									</div>
// 								</div>
// 							</li>
// 						);
// 					})}
// 				</ol>
// 			</main>
// 		</div>
// 	);
// };

// const Heading = tw.h3`
// font-medium
// text-base
// mr-20
// w-500
// txt-color-2
// `;

// const Heading1 = tw.h3`
// font-medium
// text-sm
// mr-20
// w-500
// txt-color-2
// `;

// const Heading2 = tw.span`
// font-medium 
// text-sm
// txt-color-secondary`;

// export default EmployeeSalary;
